import React from 'react';

import { Link as RouterLink } from 'react-router-dom';
import { Link, Typography } from '@material-ui/core';
// see https://material-ui.com/components/material-icons/
import { Info as InfoIcon } from '@material-ui/icons';

import { AmContainerLeft } from '../../controls/';

// Note: Copy generated by https://www.termsofservicegenerator.net/
const Tos = () => {
  // TODO: Move this to a config file.
  const site = 'app.actionsmatter.net';
  // TODO: Move this to a config file.
  const companyName = 'Actions Matter';
  return (
    <div>
      <InfoIcon color="action" style={{ fontSize: 140 }} />
      <Typography variant="h4" component="h1" color="textSecondary">
        Terms of Service
      </Typography>
      <AmContainerLeft>
        <Typography variant="h5" component="h1" color="textSecondary">
          1. Terms
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          By accessing this Website, accessible from {site}, you are agreeing to
          be bound by these Website Terms and Conditions of Use and agree that
          you are responsible for the agreement with any applicable local laws.
          If you disagree with any of these terms, you are prohibited from
          accessing this site. The materials contained in this Website are
          protected by copyright and trade mark law.
        </Typography>
        <Typography variant="h5" component="h1" color="textSecondary">
          2. Use License
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          Permission is granted to temporarily download one copy of the
          materials on {companyName}'s Website for personal, non-commercial
          transitory viewing only. This is the grant of a license, not a
          transfer of title, and under this license you may not: modify or copy
          the materials; use the materials for any commercial purpose or for any
          public display; attempt to reverse engineer any software contained on{' '}
          {companyName}'s Website; remove any copyright or other proprietary
          notations from the materials; or transferring the materials to another
          person or "mirror" the materials on any other server. This will let{' '}
          {companyName} to terminate upon violations of any of these
          restrictions. Upon termination, your viewing right will also be
          terminated and you should destroy any downloaded materials in your
          possession whether it is printed or electronic format.
        </Typography>
        <Typography variant="h5" component="h1" color="textSecondary">
          3. Disclaimer
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          All the materials on {companyName}'s Website are provided “as is”.
          {companyName} makes no warranties, may it be expressed or implied,
          therefore negates all other warranties. Furthermore, {companyName}{' '}
          does not make any representations concerning the accuracy or
          reliability of the use of the materials on its Website or otherwise
          relating to such materials or any sites linked to this Website.
        </Typography>
        <Typography variant="h5" component="h1" color="textSecondary">
          4. Limitations
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          {companyName} or its suppliers will not be hold accountable for any
          damages that will arise with the use or inability to use the materials
          on {companyName}'s Website, even if {companyName} or an authorize
          representative of this Website has been notified, orally or written,
          of the possibility of such damage. Some jurisdiction does not allow
          limitations on implied warranties or limitations of liability for
          incidental damages, these limitations may not apply to you.
        </Typography>
        <Typography variant="h5" component="h1" color="textSecondary">
          5. Revisions and Errata
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          The materials appearing on {companyName}'s Website may include
          technical, typographical, or photographic errors. {companyName} will
          not promise that any of the materials in this Website are accurate,
          complete, or current. {companyName} may change the materials contained
          on its Website at any time without notice. {companyName} does not make
          any commitment to update the materials.
        </Typography>
        <Typography variant="h5" component="h1" color="textSecondary">
          6. Links
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          {companyName} has not reviewed all of the sites linked to its Website
          and is not responsible for the contents of any such linked site. The
          presence of any link does not imply endorsement by {companyName} of
          the site. The use of any linked website is at the user's own risk.
        </Typography>
        <Typography variant="h5" component="h1" color="textSecondary">
          7. Site Terms of Use Modifications
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          {companyName} may revise these Terms of Use for its Website at any
          time without prior notice. By using this Website, you are agreeing to
          be bound by the current version of these Terms and Conditions of Use.
        </Typography>
        <Typography variant="h5" component="h1" color="textSecondary">
          8. Governing Law
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          Any claim related to {companyName}'s Website shall be governed by the
          laws of Country without regards to its conflict of law provisions.
        </Typography>
      </AmContainerLeft>
      <Link component={RouterLink} to="/" variant="body2">
        {'Return home'}
      </Link>
    </div>
  );
};

export { Tos };
